module.exports = __webpack_public_path__ + "static/img/01.b81ceec.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/01.jpg
// module id = OVX6
// module chunks = 18